import React from 'react';

import {withRouter} from 'react-router';
import {connect} from 'react-redux';

import * as Cookie from 'js-cookie';

import {isMainTaxon} from '../../utils/taxons';

import Dropdown from '../../components/dropdown/Dropdown';
import ChannelLink from '../channelUtils/ChannelLink';

@withRouter
@connect(({ui, taxons}) => ({
  activeMainTaxon: ui.activeMainTaxon,
  taxons: taxons.root.children,
  mainTaxonDropdownVisibility: ui.mainTaxonDropdownVisibility
}))
export default class MainTaxonDropdown extends React.PureComponent {
  render() {
    const {activeMainTaxon, taxons, mainTaxonDropdownVisibility} = this.props;

    if (!taxons || !mainTaxonDropdownVisibility) {
      return false;
    }

    let mainTaxons = taxons.filter(isMainTaxon);

    if (Cookie.get('blacklist')) {
      const excludedTaxons = JSON.parse(Cookie.get('blacklist'));

      mainTaxons =
        mainTaxons && mainTaxons.filter(({ slug }) => !excludedTaxons.includes(slug));
    }

    return (
      <div className="header__games">
        <Dropdown wide>
          {mainTaxons.map(taxon => (
            <Dropdown.Item
              key={taxon.code}
              active={taxon.slug === activeMainTaxon}
              component={ChannelLink}
              to={`/${taxon.slug}`}
            >
              {taxon.name}
            </Dropdown.Item>
          ))}
        </Dropdown>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./containers/mainTaxonDropdown/MainTaxonDropdown.js